import { Box, Text, Image, Heading, useDisclosure, Modal, Button, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Flex, Tooltip } from "@chakra-ui/react";
import me from '../resources/images/me.png'
import logo from '../resources/images/logov4.png'
import { GenericTableContainer } from "./GenericTableContainer";
import { ImLinkedin, ImMail, ImWhatsapp } from "react-icons/im";
import { headingPrimaryFont, maxWidth, primaryColor, secondaryColorThree, secondaryColorTwo, headingTertiaryFont, headingSecondaryFont, secondaryFontSize, bodyBGColor, secondaryColorOne } from "../config";
import NavigatableIcon from "./NavigatableIcon";
import { Author } from "./CustomUtilComponents";
export default function SelfIntroduction() {

    const { isOpen, onOpen, onClose } = useDisclosure()
    const header = ["Time", "Tasks?"]
    // change for mobile view
    const body = [
        ["1 - 4", `Don't Remember, Didn't happen? ${String.fromCodePoint(parseInt("0x1F937", 16))}`],
        ["4 - 16", `Schooling - Self Loathing; Picking up Pieces? ${String.fromCodePoint(parseInt("0x1F644", 16))}`],
        ["16 - 19", `Diploma in ECE - Life? ${String.fromCodePoint(parseInt("0x1F914", 16))}`],
        ["20 - 22", `BTECH in ECE @ RVCE - Trap?! ${String.fromCodePoint(parseInt("0x1F630", 16))}`],
        ["23 - 24", `MIT @ UOA - Twilight ${String.fromCodePoint(parseInt("0x1F60C", 16))}`],
        ["25 - 27", `SE @ Orion Health - The Beginning! ${String.fromCodePoint(parseInt("0x1F642", 16))}`]]

    function formatRow(row: string[], rowKey: number) {
        return row.map(cell => <Text textAlign={"center"} key={rowKey}>{cell}</Text>)
    }

    return (
        <>
            <Box
                maxW={{ base: "auto", lg: maxWidth }}
                m={headingSecondaryFont}
                mt={0}
                display={{ base: "block", "lg": "flex" }}
                justifyContent={"center"}>
                <Box maxW={"70rem"}>
                    <Flex alignItems={'center'} justifyContent={'space-between'}>
                        <Text fontSize={headingPrimaryFont} color={secondaryColorTwo}>Sharath?</Text>
                        <Flex justifyContent={'space-between'}>
                            <NavigatableIcon
                                icon={ImLinkedin}
                                color='#0077B5'
                                label="Connect"
                                href="https://www.linkedin.com/in/sharath-b-gowda/" />
                            <NavigatableIcon
                                icon={ImMail}
                                color='red'
                                label="Mail"
                                href="#"
                                onClick={(e) => {
                                    window.location.href = 'mailto:b.sharath240697@gmail.com';
                                    e.preventDefault();
                                }} />
                            <NavigatableIcon
                                icon={ImWhatsapp}
                                color='green'
                                label="Chat"
                                href="https://wa.me/9986216387" />
                        </Flex>
                    </Flex>

                    <Box
                        mt={0}
                        display={"flex"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        flexDirection={{ base: "column", md: "row" }}>

                        <Box width={{ base: "100%", md: "20vw" }}
                            height={"25rem"}
                            minH={"25rem"}
                            minW={"10rem"}
                            mr={{ base: 0, md: "4rem" }}
                        >
                            <Image src={me} objectFit="contain" height={"100%"} />
                        </Box>

                        <Box
                            width={{ base: "90vw", md: "50vw" }}
                            minW={{ base: "50vw", md: "25rem" }}
                            paddingTop={{ base: headingSecondaryFont, mg: "0" }}
                            flex={1}
                            color={secondaryColorTwo}
                        >
                            <Text fontSize={headingTertiaryFont} color={primaryColor}>What Have I done?</Text>
                            <Box display="flex" >
                                <GenericTableContainer dataHeader={header} dataBody={body} formatRow={formatRow} highlightRow={0} />
                            </Box>
                        </Box>
                    </Box>
                    <br />
                    <Box >
                        <Heading fontSize={headingSecondaryFont} color={primaryColor}>
                            What am I upto? Just Checking out Life {String.fromCodePoint(parseInt("0x1F3AE", 16))} in...
                        </Heading>
                        <br />
                        <Box>
                            <Box fontSize={headingTertiaryFont} display={'inline-block'} color={primaryColor} as='a' href='/blog' _hover={{
                                color: secondaryColorOne
                            }}>
                                SwaDharma Spandana! {String.fromCodePoint(parseInt("0x1F54A", 16))}
                            </Box>
                            <br />
                            <br />
                            <Text textAlign={"justify"} color={secondaryColorThree} fontSize={secondaryFontSize}>
                                I have always grappled with questions, one or the other, of all kinds, relevant, irrelevant,
                                sane, stupid, and some were answered, some are lingering in the corner of mind
                                waiting for their time, while some are forgotten, but each and every one of them have taught
                                me or rather made me realize the fact that someone else can’t answer my questions for me;
                                It’s only “I” can to myself, but not without the people, life around me.
                            </Text>
                            <Text cursor={"pointer"} color={"blue"} onClick={onOpen} textAlign={"right"}>show more...</Text>
                        </Box>
                        <br />
                        {/* <Box>
                            <Box fontSize={headingTertiaryFont} display={'inline-block'} color={primaryColor} as='a' href='/blog' _hover={{
                                color: secondaryColorOne
                            }}>
                                Prana Spandana {String.fromCodePoint(parseInt("0x1F33E", 16))}
                            </Box>
                            <br />
                            <br />
                            <Text textAlign={"justify"} color={secondaryColorThree} fontSize={secondaryFontSize}>
                                I have always grappled with questions, one or the other, of all kinds, relevant, irrelevant,
                                sane, stupid, and some were answered, some are lingering in the corner of mind
                            </Text>
                        </Box>
                        <br /> */}
                        <Box>
                            <Box fontSize={headingTertiaryFont} display={'inline-block'} color={primaryColor} as='a' href='/blog' _hover={{
                                color: secondaryColorOne
                            }}>
                                Zerofion {String.fromCodePoint(parseInt("0x1F60E", 16))}
                            </Box>
                            <br />
                            <br />
                            <Text textAlign={"justify"} color={secondaryColorThree} fontSize={secondaryFontSize}>
                                The technology is neither good nor bad, it is just a tool to be used for wellbeing.
                                <br />
                                Watch This space for The Next Phase...
                            </Text>
                        </Box>
                    </Box>
                </Box>
            </Box >

            <Modal scrollBehavior="outside" isOpen={isOpen} onClose={() => onClose()} size={"full"} >
                <ModalOverlay />
                <ModalContent
                    maxH={{ base: "full", md: "80vh" }}
                    maxW={{ base: "full", md: "70vw" }}
                    overflow="scroll" bg={bodyBGColor}
                    color={secondaryColorThree}
                    fontSize={secondaryFontSize}>
                    <ModalHeader fontWeight={"0"} pb={0}>
                        <Box textAlign={"center"}>
                            <Text fontSize={headingPrimaryFont} color={primaryColor}
                                as='a' href='/blog' _hover={{
                                    color: secondaryColorThree
                                }}>
                                SwaDharma Spandana!
                            </Text>
                        </Box>
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody m={0} p={0} >
                        <Box
                            m={{ base: 0, md: headingSecondaryFont }}
                            mt={0} pt={0}
                            display={{ base: "block", "md": "flex" }}
                            flexDir={"column"}
                            pr={{ base: headingSecondaryFont, lg: headingPrimaryFont }}
                            pl={{ base: headingSecondaryFont, lg: headingPrimaryFont }}
                            justifyContent={"center"}>
                            <Box
                                display={{ base: "block", "md": "flex" }}
                                justifyContent={"space-around"}
                            >
                                <Box width={{ base: "100%", md: "90vw" }}
                                    height={"25rem"}
                                    minH={"25rem"}
                                    minW={"10rem"}
                                    mr={{ base: 0, md: "4rem" }}
                                    mb={{ base: headingPrimaryFont, md: 0 }}
                                >
                                    <Image objectFit="contain" src={logo} alt={"me"} height={"100%"} width={"100%"} object-fit="cover" />
                                </Box>
                                <Text textAlign={"justify"} color={secondaryColorThree} fontSize={secondaryFontSize} >
                                    <Text as='span' display='block' textAlign="center" fontSize={headingTertiaryFont} color={secondaryColorTwo}>
                                        Why SwaDharma Spandana?
                                    </Text>
                                    <br />
                                    I have always grappled with questions, one or the other, of all kinds, relevant, irrelevant,
                                    sane, stupid, and some were answered, some are lingering in the corner of mind
                                    waiting for their time, while some are forgotten, but each and every one of them have taught
                                    me or rather made me realize the fact that someone else can’t answer my questions for me;
                                    It’s only “I” can to myself, but not without the people, life around me.
                                    <br />
                                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                    Like a seed that can only grow by itself but not without the soil, water, sun, and the suitable weather or the ambiance.
                                    <br /><br />
                                    Each individual is a flower, a unique one in that! The growth is of a different nature while the bloom is of a different
                                    nature whole together; how many species does our earth accommodate? Countless indeed!
                                </Text>
                            </Box>
                            <Box >
                                <Text textAlign="justify" fontSize={secondaryFontSize}>
                                    <br />
                                    The beautiful flower that only blooms for the moon, flower that blooms once in a century
                                    or decade, in moderate environment, extreme conditions of sorts, flowers with beauty, vibrancy and thorns, at the same
                                    time, stinky, fragrant, poisonous flowers that heals, kills, and a flower that has become the symbol of purity while in
                                    mud! Is there an end to it?
                                    <br />
                                    <br />
                                    Our earth is my inspiration! If she’s doing it why can’t we? And with that, this is an earnest attempt in bringing together
                                    our community, friends and family - kutumbam, vasudhivya kutumbakam, in the spirit of ‘Sanatána Dharma’, The eternal law to
                                    create the ambiance, situations necessary for individuals to bloom to their fullest; only which can reverse the direction we are heading towards.
                                    The direction of apathy, indifference, superficiality and ignorance of one’s own nature. One’s nature can only be discovered
                                    individually by their one way of deep enquiry and questioning.
                                    <br />
                                    <br />
                                    In my experience, beyond success, failure, good, bad and norms of the society that are instigating helplessness, mental illness
                                    like never before causing humans to commit suicide at a prolific rate; there are questions related to everything, everyone and
                                    simply can’t rid myself off! They have always been there, how much ever the crowd tried to bury them they have been surfaced by
                                    the time again and again!
                                    <br />
                                    <br />
                                    <Text as='span' display='block' textAlign={"center"}>
                                        {/* The questions <br /> */}
                                        What is Life? <br />
                                        What is Death? <br />
                                        And Who am I? <br />
                                    </Text>
                                    <br />
                                    Iornically these are the questions shunned in ignorance but are revered and hailed as the harbinger of awareness and consciousness,
                                    truth untouched by time; in this spirit of enquiry it&apos;s an earnest attempt to revive the symbiotic environment of life, the only
                                    way demonstrated by our earth, to find the ultimate well being, to grow, bloom and find fulfillment,
                                    <Text as='span' display='block' textAlign={"center"}>
                                        Let’s grow by being a step for one another! <br /> <br />
                                        Individuality is an ideology of the mind; <br />
                                        Love is the intelligence that is the essence of all. <br />
                                    </Text>
                                </Text>
                            </Box>
                            <Author />
                        </Box>

                        <ModalFooter justifyContent={"center"}>
                            <Button bg={primaryColor} color={"white"}
                                onClick={() => onClose()}
                                _hover={{
                                    backgroundColor: secondaryColorTwo,
                                }}>Close</Button>
                        </ModalFooter>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>)
}